import { toCanvas } from "html-to-image";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  fetchEmployees,
  generateLink,
  linkedEmployees,
  selectProcesses,
  setSelectedEmployee,
  sharedEmployees,
} from "../processSlices";
import AuthSkeleton from "../../auth/AuthSkeleton";
import { NavLink as RouterLink, useParams } from "react-router-dom";
import {
  Tooltip,
  useTheme,
  Stack,
  Box,
  Typography,
  IconButton,
  Fab,
  Container,
  Accordion,
  AccordionDetails,
  Grid,
  TextField,
} from "@mui/material";
import { GradientTemplate, LabelTemplate } from "./styles/table";
import Image from "mui-image";
import {
  ArrowBack,
  ArrowForward,
  Download,
  Edit,
  List,
  Save,
  Share,
} from "@mui/icons-material";
import { Employee, EmployeeStatus, ShortLink } from "../types/processTypes";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";

import {
  changePageTitle,
  selectPreference,
} from "../../preferences/preferencesSlice";

import CustomDialog from "../../../components/modals/CustomDialog";
import InterTemplate from "./InterTemplate";
import BasicTemplate from "./BasicTemplate";
import jsPDF from "jspdf";
import { CvTemplate } from "../../setups/types/setupTypes";
import { addCompany, getCompany, selectSetups } from "../../setups/setupSlices";
import OxagonTwoTemplate from "./OxagonTwoTemplate";
import MaledaTemplate from "./MaledaTemplate";
import BasicTwoTemplate from "./BasicTwoTemplate";
import BasicThreeTemplate from "./BasicThreeTemplate";
import EntranceTemplate from "./EntranceTemplate";
import AkeemTemplate from "./AkeemTemplate";
import CadresTemplate from "./CadresTemplate";
import SkillStarTemplate from "./SkillStarTemplate";
import SanadTemplate from "./SanadTemplate";
import BasicOxaTemplate from "./BasicOxaTemplate";
import BasicTopExperienceTemplate from "./BasicTopExperienceTemplate";
import YebadTemplate from "./YebadTemplate";
import ShareCvs from "../components/ShareCvs";
import WalifTemplate from "./WalifTemplate";
import { StyledAccordionSummary } from "../../../styles/componentStyled";
import ExpandMore from "@mui/icons-material/ExpandMore";

function PremiumTemplate() {
  // const { agencyId, agentId } = useParams() as {
  //   agencyId: string;
  //   agentId: string;
  // };
  const { link } = useParams() as {
    link: string;
  };
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const { searchText } = useAppSelector(selectPreference);
  const [open, setOpen] = useState(false);
  const [shortLink, setShortLink] = useState<ShortLink>({});

  const [name, setName] = useState("basic");
  const [numberOfPages, setNumberOfPages] = useState(2);

  const [cvLang, setCvLang] = useState("ar");
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");

  const [headFontColor, setHeadFontColor] = useState("#ffffff");
  const [headBgColor, setHeadBgColor] = useState(theme.palette.primary.main);
  const [labelFontColor, setLabelFontColor] = useState(
    theme.palette.primary.main
  );
  const [labelBgColor, setLabelBgColor] = useState("#ffffff");
  const [valueFontColor, setValueFontColor] = useState(
    theme.palette.secondary.main
  );
  const [valueBgColor, setValueBgColor] = useState("#ffffff");

  const [borderRadius, setBorderRadius] = useState("5px");
  const [borderStyle, setBorderStyle] = useState("solid");
  const [borderColor, setBorderColor] = useState("#ffffff");
  const [borderWidth, setBorderWidth] = useState(1);

  const [spacing, setSpacing] = useState(1);
  const [labelFontSize, setLabelFontSize] = useState(16);
  const [valueFontSize, setValueFontSize] = useState(18);
  const [labelFontWeight, setLabelFontWeight] = useState(900);
  const [valueFontWeight, setValueFontWeight] = useState(900);

  const [textTransform, setTextTransform] = useState("uppercase");
  const [headerHeight, setHeaderHeight] = useState(48);
  const [bodyHeight, setBodyHeight] = useState(36);

  const [addPassportHeader, setAddPassportHeader] = useState(false);
  const [useHeaderGradient, setUseHeaderGradient] = useState(true);
  const [useBodyGradient, setUseBodyGradient] = useState(false);

  const [headerShadow, setHeaderShadow] = useState("5px 5px rgba(0,0,0,0.14)");
  const [bodyShadow, setBodyShadow] = useState("5px 5px rgba(0,0,0,0.14)");
  const [photoShadow, setPhotoShadow] = useState("5px 5px rgba(0,0,0,0.14)");
  const [passportShadow, setPassportShadow] = useState(
    "5px 5px rgba(0,0,0,0.14)"
  );

  const [qrLocationLink, setQrLocationLink] = useState(
    "https://maps.app.goo.gl/ikKVLs5b6Ef2Xemw8"
  );
  const [qrLocationWidth, setQrLocationWidth] = useState(150);
  const [qrLocationHeight, setQrLocationHeight] = useState(150);
  const [qrLocationImageUrl, setQrLocationImageUrl] =
    useState("/googleMaps.png");
  const [qrLocationMargin, setQrLocationMargin] = useState(0);

  const [qrMoreCvsLink, setQrMoreCvsLink] = useState(
    "https://maps.app.goo.gl/ikKVLs5b6Ef2Xemw8"
  );
  const [qrMoreCvsWidth, setQrMoreCvsWidth] = useState(150);
  const [qrMoreCvsHeight, setQrMoreCvsHeight] = useState(150);
  const [qrMoreCvsImageUrl, setQrMoreCvsImageUrl] = useState("/googleMaps.png");
  const [qrMoreCvsMargin, setQrMoreCvsMargin] = useState(0);

  const [faceHeight, setFaceHeight] = useState("240px");
  const [faceWidth, setFaceWidth] = useState("100%");
  const [standHeight, setStandHeight] = useState("600px");
  const [standWidth, setStandWidth] = useState("400px");
  const [flagHeight, setFlagHeight] = useState("200px");
  const [flagWidth, setFlagWidth] = useState("100%");
  const [passportHeight, setPassportHeight] = useState("650px");
  const [passportWidth, setPassportWidth] = useState("700px");
  const [headBgColorAlpha, setHeadBgColorAlpha] = useState(1);
  const [headGrFirstColorAlpha, setHeadGrFirstColorAlpha] = useState(1);
  const [headGrSecondColorAlpha, setHeadGrSecondColorAlpha] = useState(1);
  const [labelBgColorAlpha, setLabelBgColorAlpha] = useState(1);
  const [oddGrFirstColorAlpha, setOddGrFirstColorAlpha] = useState(1);
  const [oddGrSecondColorAlpha, setOddGrSecondColorAlpha] = useState(1);
  const [valueBgColorAlpha, setValueBgColorAlpha] = useState(1);
  const [evenGrFirstColorAlpha, setEvenGrFirstColorAlpha] = useState(1);
  const [evenGrSecondColorAlpha, setEvenGrSecondColorAlpha] = useState(1);

  const [headerGradient, setHeaderGradient] = useState<GradientTemplate>({
    typeOfGradient: "radial-gradient",
    degree: "circle",
    firstColor: theme.palette.primary.main,
    firstPercentage: "0%",
    secondColor: theme.palette.secondary.main,
    secondPercentage: "100%",
  });
  const [evenGradient, setEvenGradient] = useState<GradientTemplate>({
    typeOfGradient: "linear-gradient",
    degree: "90deg",
    firstColor: "transparent",
    firstPercentage: "0%",
    secondColor: "transparent",
    secondPercentage: "100%",
  });
  const [oddGradient, setOddGradient] = useState<GradientTemplate>({
    typeOfGradient: "linear-gradient",
    degree: "90deg",
    firstColor: "transparent",
    firstPercentage: "0%",
    secondColor: "transparent",
    secondPercentage: "100%",
  });

  const [cvTemplate, setCvTemplate] = useState<LabelTemplate>({
    name,
    numberOfPages,
    cvLang,
    bgColor: backgroundColor,
    headFontColor,
    headBgColor,
    labelFontColor,
    labelBgColor,
    valueFontColor,
    valueBgColor,
    borderColor,
    borderRadius,
    borderWidth,
    borderStyle,
    spacing,
    labelFontSize,
    valueFontSize,
    labelFontWeight,
    valueFontWeight,
    textTransform,
    headerHeight,
    bodyHeight,
    headerGradient,
    evenGradient,
    oddGradient,
    addPassportHeader,
    useHeaderGradient,
    useBodyGradient,
    headerShadow,
    bodyShadow,
    photoShadow,
    passportShadow,
    qrLocationLink,
    qrLocationWidth,
    qrLocationHeight,
    qrLocationImageUrl,
    qrLocationMargin,
    qrMoreCvsLink,
    qrMoreCvsWidth,
    qrMoreCvsHeight,
    qrMoreCvsImageUrl,
    qrMoreCvsMargin,
    faceHeight,
    faceWidth,
    standHeight,
    standWidth,
    flagHeight,
    flagWidth,
    passportHeight,
    passportWidth,
    headBgColorAlpha,
    headGrFirstColorAlpha,
    headGrSecondColorAlpha,
    labelBgColorAlpha,
    oddGrFirstColorAlpha,
    oddGrSecondColorAlpha,
    valueBgColorAlpha,
    evenGrFirstColorAlpha,
    evenGrSecondColorAlpha,
  });

  useEffect(() => {
    setCvTemplate({
      name,
      numberOfPages,
      cvLang,
      bgColor: backgroundColor,
      headFontColor,
      headBgColor,
      labelFontColor,
      labelBgColor,
      valueFontColor,
      valueBgColor,
      borderColor,
      borderRadius,
      borderWidth,
      borderStyle,
      spacing,
      labelFontSize,
      valueFontSize,
      labelFontWeight,
      valueFontWeight,
      textTransform,
      headerHeight,
      bodyHeight,
      headerGradient,
      evenGradient,
      oddGradient,
      addPassportHeader,
      useHeaderGradient,
      useBodyGradient,
      headerShadow,
      bodyShadow,
      photoShadow,
      passportShadow,
      qrLocationLink,
      qrLocationWidth,
      qrLocationHeight,
      qrLocationImageUrl,
      qrLocationMargin,
      qrMoreCvsLink,
      qrMoreCvsWidth,
      qrMoreCvsHeight,
      qrMoreCvsImageUrl,
      qrMoreCvsMargin,
      faceHeight,
      faceWidth,
      standHeight,
      standWidth,
      flagHeight,
      flagWidth,
      passportHeight,
      passportWidth,
      headBgColorAlpha,
      headGrFirstColorAlpha,
      headGrSecondColorAlpha,
      labelBgColorAlpha,
      oddGrFirstColorAlpha,
      oddGrSecondColorAlpha,
      valueBgColorAlpha,
      evenGrFirstColorAlpha,
      evenGrSecondColorAlpha,
    });
  }, [
    headFontColor,
    headBgColor,
    labelFontColor,
    labelBgColor,
    valueFontColor,
    valueBgColor,
    borderColor,
    borderRadius,
    borderWidth,
    borderStyle,
    spacing,
    labelFontSize,
    valueFontSize,
    labelFontWeight,
    valueFontWeight,
    textTransform,
    headerHeight,
    bodyHeight,
    cvLang,
    headerGradient,
    evenGradient,
    oddGradient,
    useHeaderGradient,
    useBodyGradient,
    name,
    numberOfPages,
    backgroundColor,
    addPassportHeader,
    headerShadow,
    bodyShadow,
    photoShadow,
    passportShadow,
    qrLocationLink,
    qrLocationWidth,
    qrLocationHeight,
    qrLocationImageUrl,
    qrLocationMargin,
    qrMoreCvsLink,
    qrMoreCvsWidth,
    qrMoreCvsHeight,
    qrMoreCvsImageUrl,
    qrMoreCvsMargin,
    faceHeight,
    faceWidth,
    standHeight,
    standWidth,
    flagHeight,
    flagWidth,
    passportHeight,
    passportWidth,
    headBgColorAlpha,
    headGrFirstColorAlpha,
    headGrSecondColorAlpha,
    labelBgColorAlpha,
    oddGrFirstColorAlpha,
    oddGrSecondColorAlpha,
    valueBgColorAlpha,
    evenGrFirstColorAlpha,
    evenGrSecondColorAlpha,
  ]);

  const {
    selectedEmployee: currentEmployee,
    employeesWithCount: { employees },
    selectedShortLink,
    success,
    loading,
  } = useAppSelector(selectProcesses);

  const { selectedCompany } = useAppSelector(selectSetups);

  const renderCvFormat = (cv: CvTemplate) => {
    setName(cv.name);
    setNumberOfPages(cv.numberOfPages);
    setCvLang(cv.cvLang);
    setBackgroundColor(cv.bgColor);
    setHeadFontColor(cv.headFontColor);
    setHeadBgColor(cv.headBgColor);
    setLabelFontColor(cv.labelFontColor);
    setLabelBgColor(cv.labelBgColor);
    setValueFontColor(cv.valueFontColor);
    setValueBgColor(cv.valueBgColor);

    setBorderColor(cv.borderColor);
    setBorderRadius(cv.borderRadius);
    setBorderWidth(cv.borderWidth);
    setBorderStyle(cv.borderStyle);
    setSpacing(cv.spacing);
    setLabelFontSize(cv.labelFontSize);
    setValueFontSize(cv.valueFontSize);
    setLabelFontWeight(cv.labelFontWeight);
    setValueFontWeight(cv.valueFontWeight);
    setTextTransform(cv.textTransform);
    setHeaderHeight(cv.headerHeight);
    setBodyHeight(cv.bodyHeight);

    setAddPassportHeader(cv.addPassportHeader);
    setUseHeaderGradient(cv.useHeaderGradient);
    setUseBodyGradient(cv.useBodyGradient);

    setHeaderShadow(cv.headerShadow);
    setBodyShadow(cv.bodyShadow);
    setPhotoShadow(cv.photoShadow);
    setPassportShadow(cv.passportShadow);

    setQrLocationLink(cv.qrLocationLink);
    setQrLocationWidth(cv.qrLocationWidth);
    setQrLocationHeight(cv.qrLocationHeight);
    setQrLocationImageUrl(cv.qrLocationImageUrl);
    setQrLocationMargin(cv.qrLocationMargin);

    setQrMoreCvsLink(cv.qrMoreCvsLink);
    setQrMoreCvsWidth(cv.qrMoreCvsWidth);
    setQrMoreCvsHeight(cv.qrMoreCvsHeight);
    setQrMoreCvsImageUrl(cv.qrMoreCvsImageUrl);
    setQrMoreCvsMargin(cv.qrMoreCvsMargin);

    setFaceHeight(cv.faceHeight);
    setFaceWidth(cv.faceWidth);
    setStandHeight(cv.standHeight);
    setStandWidth(cv.standWidth);
    setFlagHeight(cv.flagHeight);
    setFlagWidth(cv.flagWidth);
    setPassportHeight(cv.passportHeight);
    setPassportWidth(cv.passportWidth);

    setHeadBgColorAlpha(cv.headBgColorAlpha);
    setHeadGrFirstColorAlpha(cv.headGrFirstColorAlpha);
    setHeadGrSecondColorAlpha(cv.headGrSecondColorAlpha);
    setLabelBgColorAlpha(cv.labelBgColorAlpha);
    setOddGrFirstColorAlpha(cv.oddGrFirstColorAlpha);
    setOddGrSecondColorAlpha(cv.oddGrSecondColorAlpha);
    setValueBgColorAlpha(cv.valueBgColorAlpha);
    setEvenGrFirstColorAlpha(cv.evenGrFirstColorAlpha);
    setEvenGrSecondColorAlpha(cv.evenGrSecondColorAlpha);

    const headerGr = cv.headerGradient.split("_");
    if (headerGr.length === 6) {
      setHeaderGradient({
        typeOfGradient: headerGr[0],
        degree: headerGr[1],
        firstColor: headerGr[2],
        firstPercentage: headerGr[3],
        secondColor: headerGr[4],
        secondPercentage: headerGr[5],
      });
    }

    const evenGr = cv.evenGradient.split("_");
    if (evenGr.length === 6) {
      setEvenGradient({
        typeOfGradient: evenGr[0],
        degree: evenGr[1],
        firstColor: evenGr[2],
        firstPercentage: evenGr[3],
        secondColor: evenGr[4],
        secondPercentage: evenGr[5],
      });
    }
    const oddGr = cv.oddGradient.split("_");
    if (oddGr.length === 6) {
      setOddGradient({
        typeOfGradient: oddGr[0],
        degree: oddGr[1],
        firstColor: oddGr[2],
        firstPercentage: oddGr[3],
        secondColor: oddGr[4],
        secondPercentage: oddGr[5],
      });
    }
  };

  useEffect(() => {
    if (currentEmployee) {
      if (
        currentEmployee.prospects &&
        currentEmployee.prospects[0] &&
        currentEmployee.prospects[0]._id
      ) {
        dispatch(getCompany(currentEmployee.prospects[0]._id));
      } else if (currentEmployee.owner && currentEmployee.owner._id) {
        dispatch(getCompany(currentEmployee.owner._id));
      }
    }
  }, [dispatch, currentEmployee]);

  useEffect(() => {
    if (selectedCompany && selectedCompany._id) {
      if (selectedCompany.cvTemplate) {
        renderCvFormat(selectedCompany.cvTemplate);
      } else {
        //renderCvFormat(currentEmployee.owner.cvTemplate);
        //console.log(selectedCompany);
      }
    }
  }, [dispatch, selectedCompany]);

  useEffect(() => {
    dispatch(changePageTitle("Cvs Detail"));
    if (!employees || employees.length === 0 || searchText) {
      if (link && link.length === 6) {
        dispatch(
          sharedEmployees({
            link: link,
            refreshList: "network-only",
          })
        );
      } else {
        dispatch(
          fetchEmployees({
            searchText: "",
            skip: 0,
            take: 500,
            status: EmployeeStatus.new,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchText, link]);

  useEffect(() => {
    if (employees && employees.length > 0) {
      if (currentEmployee.givenName === "") {
        dispatch(setSelectedEmployee(employees[0]));
      } else {
        let indexOf = employees.findIndex(
          (e: Employee) => e._id === currentEmployee._id
        );
        dispatch(setSelectedEmployee(employees[indexOf]));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, employees]);

  const previousEmployee = () => {
    let indexOf = employees.findIndex(
      (e: Employee) => e._id === currentEmployee._id
    );
    if (indexOf === 0) indexOf = employees.length - 1;
    else indexOf--;
    dispatch(setSelectedEmployee(employees[indexOf]));
  };
  const nextEmployee = () => {
    let indexOf = employees.findIndex(
      (e: Employee) => e._id === currentEmployee._id
    );
    if (indexOf === employees.length - 1) indexOf = 0;
    else indexOf++;
    dispatch(setSelectedEmployee(employees[indexOf]));
  };

  const shareSingle = (employeeId: string) => {
    dispatch(generateLink({ employeeIds: [employeeId] }));
    //setOpen(true);
  };
  const dialogClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (success && selectedShortLink && selectedShortLink.link) {
      setOpen(true);
      setShortLink(selectedShortLink);
    }
  }, [success, selectedShortLink]);

  const handleGeneratePdf = () => {
    const fileName = currentEmployee.givenName as string;

    if (numberOfPages === 1) {
      const doc = new jsPDF("p", "mm", "a4", false);
      toCanvas(document.getElementById("personalData") as HTMLElement)
        .then((canvas) => {
          //const imgWidth = canvas.width;
          //const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const imgData = canvas.toDataURL("image/png");
          doc.addImage({
            imageData: imgData,
            format: "PNG",
            x: 4,
            y: 4,
            width: 200,
            height: 290,
            alias: "alias1",
            compression: "FAST",
          });
          doc.save(`${fileName}.pdf`);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const doc = new jsPDF("p", "mm", "a4", false);
      toCanvas(document.getElementById("personalData") as HTMLElement)
        .then((canvas) => {
          //const imgWidth = 200;
          //const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const imgData = canvas.toDataURL("image/png");
          doc.addImage({
            imageData: imgData,
            format: "PNG",
            x: 4,
            y: 4,
            width: 200,
            height: 290,
            alias: "alias1",
            compression: "FAST",
          });

          doc.addPage();
          toCanvas(document.getElementById("passportData") as HTMLElement)
            .then((canvas2) => {
              //const imgWidth2 = 100;
              //const imgHeight2 = (canvas.height * imgWidth2) / canvas2.width;
              const imgData2 = canvas2.toDataURL("image/png");
              //console.log(imgData);
              doc.addImage({
                imageData: imgData2,
                format: "PNG",
                x: 4,
                y: 4,
                width: 200,
                height: 290,
                alias: "alias2",
                compression: "FAST",
              });
              doc.save(`${fileName}.pdf`);
              // doc.save("download.pdf", { returnPromise: true })
              //   .then((pdfFile) => {

              // });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const saveSelectedCompanyCvTemplate = () => {
      //console.log(selectedCompany);
      let hg = headerGradient,
        eg = evenGradient,
        og = oddGradient;
      const headerGr =
          hg.typeOfGradient +
          "_" +
          hg.degree +
          "_" +
          hg.firstColor +
          "_" +
          hg.firstPercentage +
          "_" +
          hg.secondColor +
          "_" +
          hg.secondPercentage,
        evenGr =
          eg.typeOfGradient +
          "_" +
          eg.degree +
          "_" +
          eg.firstColor +
          "_" +
          eg.firstPercentage +
          "_" +
          eg.secondColor +
          "_" +
          eg.secondPercentage,
        oddGr =
          og.typeOfGradient +
          "_" +
          og.degree +
          "_" +
          og.firstColor +
          "_" +
          og.firstPercentage +
          "_" +
          og.secondColor +
          "_" +
          og.secondPercentage;
  
      const cvTemp: CvTemplate = {
        name,
        numberOfPages,
        cvLang,
        bgColor: backgroundColor,
        headFontColor,
        headBgColor,
        labelFontColor,
        labelBgColor,
        valueFontColor,
        valueBgColor,
        borderColor,
        borderRadius,
        borderStyle,
        borderWidth,
        spacing,
        labelFontSize,
        valueFontSize,
        labelFontWeight,
        valueFontWeight,
        headerHeight,
        bodyHeight,
        textTransform,
        addPassportHeader,
        useHeaderGradient,
        useBodyGradient,
        headerGradient: headerGr,
        evenGradient: evenGr,
        oddGradient: oddGr,
        headerShadow,
        bodyShadow,
        photoShadow,
        passportShadow,
        qrLocationLink,
        qrLocationWidth,
        qrLocationHeight,
        qrLocationImageUrl,
        qrLocationMargin,
        qrMoreCvsLink,
        qrMoreCvsWidth,
        qrMoreCvsHeight,
        qrMoreCvsImageUrl,
        qrMoreCvsMargin,
        faceHeight,
        faceWidth,
        standHeight,
        standWidth,
        flagHeight,
        flagWidth,
        passportHeight,
        passportWidth,
        headBgColorAlpha,
        headGrFirstColorAlpha,
        headGrSecondColorAlpha,
        labelBgColorAlpha,
        oddGrFirstColorAlpha,
        oddGrSecondColorAlpha,
        valueBgColorAlpha,
        evenGrFirstColorAlpha,
        evenGrSecondColorAlpha,
      };
      //console.log(cvTemp);
      dispatch(
        addCompany({
          ...selectedCompany,
          cvTemplate: { ...cvTemp },
        })
      );
  };
  
  return (
    <Container maxWidth="lg">
      {employees && employees.length > 0 ? (
        <Box>
          <>
            <Stack direction="row" justifyContent="space-between">
              <>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="flex-start"
                  sx={{
                    width: "100%",
                    "& > :not(style)": {
                      m: 0,
                      ml: 1,
                    },
                  }}
                >
                  <Tooltip title="Previous" sx={{ mt: 30 }}>
                    <Fab component="span" color="primary">
                      <IconButton
                        color="inherit"
                        onClick={previousEmployee}
                        size="large"
                      >
                        <ArrowBack />
                      </IconButton>
                    </Fab>
                  </Tooltip>
                  <Tooltip title="Show List">
                    <Button
                      color="secondary"
                      component={RouterLink}
                      variant="contained"
                      to={`/app/cvs`}
                      size="small"
                    >
                      <List />
                    </Button>
                  </Tooltip>

                  <Tooltip title="Download CV">
                    <Button
                      color="secondary"
                      onClick={handleGeneratePdf}
                      variant="contained"
                      size="small"
                    >
                      <Download />
                    </Button>
                  </Tooltip>
                  {/* <Typography
                        alignSelf="center"
                        fontSize="sm"
                        fontFamily="Noto Sans Ethiopic"
                        fontWeight="extrabold"
                        color="error"
                        sx={{ opacity: 1 }}
                      >{`Before downloading adjust your browser's zoom & screen resolution:${window.screen.width}X${window.screen.height}`}</Typography>
                    */}
                </Stack>
              </>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  width: "100%",
                  "& > :not(style)": {
                    m: 0,
                    ml: 1,
                  },
                }}
              >
                {!link && (
                  <Tooltip title="Edit Detail">
                    <Button
                      color="secondary"
                      component={RouterLink}
                      variant="contained"
                      to={`/app/employee/${currentEmployee._id as string}`}
                      size="small"
                    >
                      <Edit />
                    </Button>
                  </Tooltip>
                )}
                <Tooltip title="Share Candidate">
                  <Button
                    color="secondary"
                    onClick={() => shareSingle(currentEmployee._id as string)}
                    variant="contained"
                    size="small"
                  >
                    <Share />
                  </Button>
                </Tooltip>
                <Tooltip title="Next" sx={{ mt: 30 }}>
                  <Fab component="span" color="primary">
                    <IconButton
                      color="inherit"
                      onClick={nextEmployee}
                      size="large"
                    >
                      <ArrowForward />
                    </IconButton>
                  </Fab>
                </Tooltip>
              </Stack>
            </Stack>
          </>
         
            <Accordion>
              <StyledAccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h6" component="div">
                  Change Photo Size
                </Typography>
              </StyledAccordionSummary>

              <AccordionDetails>
                <Grid container xs={12} spacing={3}>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="faceHeight"
                      label="Face Height"
                      onChange={(e) => {
                       
                        setFaceHeight(e.target.value);
                      }}
                      value={faceHeight}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="faceWidth"
                      label="Face Width"
                      onChange={(e) => {
                        
                        setFaceWidth(e.target.value);
                      }}
                      value={faceWidth}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="standHeight"
                      label="Stand Height"
                      onChange={(e) => {
                        setStandHeight(e.target.value);
                      }}
                      value={standHeight}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="standWidth"
                      label="Stand Width"
                      onChange={(e) => {
                        setStandWidth(e.target.value);
                      }}
                      value={standWidth}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  

                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="passportHeight"
                      label="Passport Height"
                      onChange={(e) => {
                        setPassportHeight(e.target.value);
                      }}
                      value={passportHeight}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      id="passportWidth"
                      label="Passport Width"
                      onChange={(e) => {
                        setPassportWidth(e.target.value);
                      }}
                      value={passportWidth}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
          {/* <Grid item xs={12}>
            <Button
              color="warning"
              variant="contained"
              sx={{ width: "100%" }}
              onClick={saveSelectedCompanyCvTemplate}
            >
              <Save /> Save Template
            </Button>
          </Grid> */}
                </Grid>
              </AccordionDetails>
            </Accordion>
          
          <Box
            component={Paper}
            elevation={3}
            sx={{
              display: "block",
              overflow: "hidden",
              width: "100%",
              mt: 1,
            }}
            id="printCV"
          >
            <div dir={theme.direction === "rtl" ? "ltr" : "ltr"}>
              {name === "basic" ? (
                <BasicTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "basic0" ? (
                <BasicTopExperienceTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "basic2" ? (
                <BasicTwoTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "basic3" ? (
                <BasicThreeTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "entrance" ? (
                <EntranceTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "akeem" ? (
                <AkeemTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "cadres" ? (
                <CadresTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "yebad" ? (
                <YebadTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "oxagon" ? (
                <OxagonTwoTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "oxagon2" ? (
                <BasicOxaTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "maleda" ? (
                <MaledaTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "walif" ? (
                <WalifTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "stars" ? (
                <SkillStarTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : name === "sanad" ? (
                <SanadTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              ) : (
                <InterTemplate
                  backgroundColor={backgroundColor}
                  cvTemplate={cvTemplate}
                  currentEmployee={currentEmployee}
                  selectedCompany={selectedCompany}
                />
              )}
            </div>
          </Box>
        </Box>
      ) : loading === "pending" ? (
        <AuthSkeleton />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <Image
            src="/No_Data.svg"
            alt="No Data"
            width={250}
            height={120}
            shift="top"
            distance="2rem"
            shiftDuration={320}
            style={{
              borderRadius: "50%",
            }}
          />
          <Typography variant="h5">No CV Found</Typography>
        </Box>
      )}
      <CustomDialog
        title="Shared Links"
        isOpen={open}
        handleDialogClose={dialogClose}
      >
        <ShareCvs
          link={shortLink.link as string}
          employees={
            shortLink.employees?.map((e) => e.givenName).join(", ") as string
          }
        />
      </CustomDialog>{" "}
      {/* <CustomDialog
        title="Agency/Agent Link"
        isOpen={open}
        handleDialogClose={dialogClose}
      >
        {currentEmployee &&
        currentEmployee.owner &&
        currentEmployee.owner._id &&
        currentEmployee.prospects &&
        currentEmployee.prospects[0] &&
        currentEmployee.prospects[0]._id ? (
          <Typography variant="h4">
            {`https://enjazplus.com/cpp/${currentEmployee.owner._id}/${currentEmployee.prospects[0]._id}?lng=ar`}
          </Typography>
        ) : (
          <Typography variant="h4">
            No Agent/Company Assigned to Employee
          </Typography>
        )}
      </CustomDialog>{" "} */}
    </Container>
  );
}

export default PremiumTemplate;
